import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import React from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  Title,
  Legend,
  Tooltip,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  CategoryScale
);

const BarChart = ({ options, data, height = 250, style }) => {
  return <Bar height={height} options={options} data={data} style={style} />;
};

export default BarChart;
